<template>
  <div class="p-6 bg-white rounded-lg">
    <h3 class="text-2xl font-medium mb-4 pb-2 border-b">Gold Marketing Pack</h3>
    Provides link to the Gold Marketing pack order form.
  </div>
</template>

<script>
export default {

}
</script>
